<template>
  <span v-if="links.length" class="order-equipment-links">
    <span v-for="link in links" :key="link.key" class="order-equipment-links__item">
      <v-icon x-small class="mr-1">{{ link.icon }}</v-icon>
      <router-link :target="target" :to="link.to">{{ link.label }}</router-link>
    </span>
  </span>
  <span v-else-if="fallback" class="text--disabled">{{ fallback }}</span>
</template>

<script>
import { VEHICLE_KINDS } from '../CommissioningMixin'

/**
 * L'équipement d'une commande, chacun vers sa fiche : la borne posée, le compteur, le véhicule, les badges activés.
 * Tant que rien n'est posé ni activé, rien ne s'affiche (ou `fallback`).
 */
export default {
  name: 'OrderEquipmentLinks',

  props: {
    order: { type: Object, required: true },
    /** Ce qui s'affiche quand la commande n'a encore aucun équipement. */
    fallback: { type: String, default: null },
    target: { type: String, default: '_blank' },
  },

  computed: {
    links() {
      const o = this.order
      if (o.kind === 'charging-point' && o.equipmentId) {
        return [{ key: o.equipmentId, icon: 'mdi-ev-station', label: o.equipmentLabel || o.equipmentId, to: { name: 'charging-points.detail', params: { id: o.equipmentId } } }]
      }
      if (o.kind === 'meter-device' && o.equipmentId) {
        return [{ key: o.equipmentId, icon: 'mdi-meter-electric-outline', label: o.equipmentLabel || o.equipmentId, to: { name: 'meter-device.detail', params: { id: o.equipmentId } } }]
      }
      if (VEHICLE_KINDS.includes(o.kind) && o.vehicleId) {
        return [{ key: o.vehicleId, icon: 'mdi-car-electric-outline', label: this.$t('onboarding.commissioning.see-vehicle'), to: { name: 'vehicle.detail', params: { id: o.vehicleId } } }]
      }
      if (o.kind === 'badge') {
        return this.badgeLinks(o)
      }
      return []
    },
  },

  methods: {
    /**
     * Les badges de la commande : posée, elle tient leurs tokens (`equipmentId`, séparés par des virgules) ; avant,
     * ceux déjà activés. Chacun par son numéro imprimé, sinon celui noté à l'envoi, sinon son type, sinon son rang.
     */
    badgeLinks(o) {
      const activated = o.activatedBadges || {}
      // Une ancienne commande gardait ses badges activés en liste, sans leur type.
      const kindOf = Array.isArray(activated) ? {} : Object.fromEntries(Object.entries(activated).map(([kind, tokenId]) => [tokenId, kind]))
      const tokenIds = o.equipmentId ? o.equipmentId.split(',').filter(Boolean) : Object.values(activated).filter(Boolean)
      const designated = o.designatedBadges || {}
      const printed = o.badgeLabels || {}
      return tokenIds.map((tokenId, index) => {
        const kind = kindOf[tokenId]
        return {
          key: tokenId,
          icon: 'mdi-card-account-details-outline',
          label: printed[tokenId] || (kind && designated[kind]) || (kind ? this.$t(`onboarding.commissioning.badge-kind.${kind}`) : this.$t('onboarding.commissioning.badge-number', { number: index + 1 })),
          to: { name: 'tokens.detail', params: { id: tokenId } },
        }
      })
    },
  },
}
</script>

<style scoped>
.order-equipment-links {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px 12px;
}
.order-equipment-links__item {
  white-space: nowrap;
}
</style>
